<template>
<div>

<alert-box @close="msg.title=''" v-bind:msg="msg"  ></alert-box>



<div class="card border-info mb-3" >
<div class="card-body">
<h4><strong>MODIFICA LISTINO</strong></h4>
<product-info v-bind:productId="item.productId"></product-info>


  <div class="table-responsive-sm table-sm">              
  <table class="table table-bordered" id="listino">
    <thead class="thead-light">
      <tr>
        <th 

         class = "text-center"  
         v-bind:style="{ color: index > 0 ? 'black':'blue', backgroundColor : index > 0 ? '#9ACD32':'' }"
         v-for="(key,index) in cols" :key="index">
            <!--<small  v-if="key!='LISTINO'" id="sizeHelp" class="form-text text-muted">Mis.</small>-->
            <span 
             v-bind:style="{ color :  key !='LISTINO' ? 'black' : 'blue' }"
             >{{key}}</span>
            
        </th>
      </tr>
    </thead>
    <tbody>
      <tr v-for="(item, index1) in items" :key="index1">
     
        <td v-for="(col,index2) in cols" :key="index2" >
        
          <div  v-if="col != 'LISTINO'" >
            <input v-on:keydown="keyHandler($event,'Dec')" v-model.number = "item[col]" class="form-control inputClass"  v-bind:name="item['Listino'] + '|' + col " type="number" v-bind:placeholder="'prezzo di '+ item['Listino'].toUpperCase()"  >
          </div>
          <div v-else >
             <div class="input-group mb-3">
              <input v-focus  class="form-control"  v-on:keydown="keyHandler($event,'Dec')"  v-bind:name="'price_' + item['Listino']" type="number" v-bind:placeholder="'Prezzo di  ' + item['Listino']">
               <div class="input-group-append">
                    
                    <span   @click="repeatPrice(index1)" class="input-group-text pointer" data-toggle="tooltip"  title="Ripeti prezzo per ogni misura"><i class="fas fa-clone mr-2" aria-hidden="true"></i></span>
                  </div>
             </div>
            
          </div>
        
        </td>
      </tr>
    </tbody>
  </table>

  </div>

<!--
  <label-price-list :key="refresh" @update="setLabel" v-bind:product="product"></label-price-list>  
-->

</div>


 </div>

<div class="row">
  <div class="col-sm-6">
    <div class="card border-info mb-3" >
      <div class="card-body">
        <h4 class="card-title"><strong>MODIFICA SCONTO</strong></h4>

        <div class="row ml-3">
        <discount-list v-if="refresh" v-bind:discounts="discounts" @update="setDiscountList"></discount-list>
        </div>

        
      </div>
    </div>
  </div>
  <div class="col-sm-6">
    <div class="card border-info mb-3" >
      <div class="card-body">
        <h4 class="card-title"><strong>MODIFICA IVA</strong></h4>
         <div class="form-group">
      <label for="vat">Iva</label>
      <input  v-on:keydown="keyHandler($event,'Num')" v-model="vat" type="number" class="form-control inputClass" placeholder="" name="vat" id = "vat">
    </div>
        
      </div>
    </div>
  </div>
</div>






  <button :disabled="bt_spinner" @click="submit()"  class="btn btn-primary float-right mt-1 mr-3">
     <i class="fas fa-save mr-3" aria-hidden="true"></i> 
      SALVA E TERMINA
    <span v-if="bt_spinner"  class="spinner-border spinner-border-sm ml-3" role="status" aria-hidden="true"></span>
  </button>



</div> 

</template>

<script>

import alertBox           from '@/components/common/AlertBox.vue';   
import api                from '@/api'             
import ProductInfo        from '@/components/product/ProductInfo.vue';
import keyHandler         from '@/components/mixins/keyHandler'
import discountList       from '@/components/backOffice/ready/DiscountList.vue'

//import labelPriceList     from '@/components/backOffice/ready/LabelPriceList.vue'


export default {
   components: {alertBox,ProductInfo,discountList},  
  props: ['item'],
  mixins: [keyHandler],
  data () {
    return {

      
      items           : [],
      cols            : [],
      discount        : 0.00,
      discounts       : [],
      vat             : 0,
      msg             : {
        title : '',
        body  : '',
        type  : 0
      },
      
      

      bt_spinner      : false,
      //product         : {sizes:[]},
      refresh         : false,
      
      

    }
  },
  computed: 
  {
  
  
   
  
  },
   directives: 
    {
      focus: {
      // directive definition
      inserted: function (el) 
      {
        if(el.name == 'price_acquisto')
        {
          el.focus() 
        }

        
      }
      }
    },
  mounted()
    {
      //$('input:visible:enabled:first').focus();  
    },
  async created()
  {
     
    this.spinner  = true
    var data      = {'productId' : this.item.productId,'movementId' : this.item.movementId}  
    var sp        = {'sp' : 'spProductMovement' }
    var json      = Object.assign(data, sp)
    
    await api.post(json).then(res => {
      if(res.status==200)
        {
            var items = res.data.recordsets
            this.createItems(items[2],items[3]) 
            
            this.discounts = items[5]
            this.refresh = true

            items[0].forEach(item=>{
            if(item.discount != null)
            {
              this.discount = item.discount
              this.vat      = item.vat 
           
           }
         })         
        }
        else if(res.status==500)
        {
          
          this.msg.title  = 'ATTENZIONE '
          this.msg.body   = res.data
          this.msg.type   = 1

        } 
        else
        {
                    
          this.msg.title  = 'ATTENZIONE '
          this.msg.body   = res
          this.msg.type   = 1                
        } 
    }).catch(err => 
    {
      
          this.msg.title  = 'ATTENZIONE '
          this.msg.body   = err.message
          this.msg.type   = 1                
        
    }).finally(() => {
      this.spinner = false
    });
    

        

    
  },

  methods: 
  {
   setDiscountList(d1,d2,d3)
   {
     this.discounts = []
      if(d1>0)
      {
      this.discounts.push({
        'discount':d1,'order_by':1    
    
      })
      }
      if(d2>0)
      {
      this.discounts.push({
        'discount':d2,'order_by':2    
    
      })
      }
      if(d3>0)
      {
      this.discounts.push({
        'discount':d3,'order_by':3
    
      })
      }
   }, 
   setLabel(items)
   {
     
     this.labels = items
     

   },
    formatEuro(v)
    {
      var formatter = new Intl.NumberFormat('de-DE', {
      //style      : 'currency',
      minimumFractionDigits : 2, 
      maximumFractionDigits : 2,
      currency              : 'EUR',
    });

      return formatter.format(v); 
    },
   
    

    submit() 
      {
        
       
        
        if(this.vat.length == 0)
        {
          this.vat = 0
        }

        this.msg.title = ''               
        var priceList  = this.items.filter(item => (item.Listino == 'acquisto')) 
        let err = false        
        this.cols.forEach(item => {
          if(item != 'LISTINO')
          {          
            if(this.formatEuro(priceList[0][item]) == '0,00')
            {
              
              this.msg.title = 'ATTENZIONE '
              this.msg.body  = "Prezzo di acquisto non valido per la misura " + ' ' + item
              this.msg.type  = 1
              err = true
              
              
            }          
          }
        })
        if(err)
        {         
          return
        }
        var priceList           = this.items.filter(item => (item.Listino == 'vendita')) 
        err = false
        this.cols.forEach(item => {
          if(item != 'LISTINO')
          {        
            if(this.formatEuro(priceList[0][item]) == '0,00')
            {
              
              this.msg.title  = 'ATTENZIONE '
              this.msg.body   = "Prezzo di vendita non valido per la misura " + ' ' + item
              this.msg.type   = 1
              err = true

                            
            }                      
          }
        })
        
        if(err)
        {          
          return
        }
                
        var data                = {}
        data.header             = {}
        data.body               = {}
        
        data.header.movementId  = this.item.movementId
        data.header.productId   = this.item.productId
        //data.header.discount    = parseInt(this.discount)
        //data.header.discount    = this.discount
        data.header.discountList = this.discounts


        data.header.vat         = parseInt(this.vat)
        var priceList           = this.items.filter(item => (item.Listino == 'acquisto')) 
        var arr                 = []
       

        this.cols.forEach(item => {
          if(item != 'LISTINO')
          {
        
            arr.push({'sizeId' : priceList[0][item + '_Id'] ,'price' : priceList[0][item]})
          
          }
        })
        
        data.body.costPrice      = arr
       
       
        var priceList           = this.items.filter(item => (item.Listino == 'vendita')) 
        var arr                 = []
        this.cols.forEach(item => {
          if(item != 'LISTINO')
          {
            //console.log('Item',item) 

            arr.push({'sizeId' : priceList[0][item+'_Id'] ,'price' : priceList[0][item]})
          
          }
        })
        
        data.body.retailPrice    = arr
        
      
      

       // return
        this.saveData(data)
        
        
      },
    async saveData(data)
    {
       

        var sp      = {'sp' : 'spUpdateProductMovementPriceList'}
        var json    = Object.assign(data, sp)
        
        this.msg.title = ''
        this.bt_spinner = true

        await api.post(json).then(res => {
          if(res.status==200)
            {
               this.$emit('update')             
            }
            else if(res.status==500)
            {
              
              this.msg.title = 'ATTENZIONE'
              this.msg.body  = res.data
              this.msg.type  = 1

            } 
            else
            {
              
              this.msg.title = 'ATTENZIONE'
              this.msg.body  = res
              this.msg.type  = 1                
            } 
        }).catch(err => 
        {
          console.log(err.message)    
        }).finally(() => {
          this.spinner = false
        });



     
          
    },



   


    createItems(rowData1,rowData2)
      {

        var sizes = []
         sizes =  _.uniqBy(
            _.map(rowData2, function(object) {
              return _.pick(object, ['size','sizeId']);
            }),"sizeId"
          );   
                
        this.cols.push('LISTINO')      
        
        sizes.forEach(item =>
        {
          this.cols.push(item.size)
        })

        // create items 
        var obj1 = {'Listino':'acquisto'}        
        rowData2.forEach(item =>
        {
         
          obj1[item.size + '_Id' ]  = item.sizeId
          obj1[item.size]  = item.price

        })

        this.$set(this.items, 0, obj1)          
                
        var obj2 = {'Listino':'vendita'}        
        var check = 0
        rowData1.forEach(item =>
        {
          check++
          obj2[item.size + '_Id' ]  = item.sizeId
          obj2[item.size]  = item.price
          
          
        })
        
        // Listino senza MISURE
        if(check==0)
        {
          rowData2.forEach(item =>
          {
            obj2[item.size + '_Id' ]  = item.sizeId
            obj2[item.size]  = 0

          })
        }
        
        this.$set(this.items, 1, obj2)          
       

       //console.log('ITEMS',this.items)

      },


      repeatPrice(index)
      {
       
        //console.log('Listino',this.items)
        
        var costPrice    = document.getElementsByName("price_acquisto")[0].value
        var retailPrice  = document.getElementsByName("price_vendita")[0].value
        //console.log('ACQUISTO',purchase_price)

         if(index==0)
        {
          if(this.formatEuro(costPrice)=='0,00')
          {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'Prezzo di acquisto base non valido.'
              this.msg.type = 1
              

              return     
          }
        }
        if(index==1)
        {
          if(this.formatEuro(retailPrice)=='0,00')
          {
              this.msg.title = 'ATTENZIONE '
              this.msg.body = 'Prezzo di vendita base non valido.'
              this.msg.type = 1
              

              return     
          }
        }



        if (index==0)
        {
          this.cols.forEach(col =>
          {              
            if (col != 'LISTINO')
            {
              
              this.items[0][col] = parseFloat(costPrice).toFixed(2)

              //console.log('Pr',this.items[index][col].price)         
            }    
          })
        }
        else
        {
          this.cols.forEach(col =>
          {  
            if (col != 'LISTINO')
            {
             // document.getElementsByName("vendita|"+col)[0].value = selling_price
              this.items[1][col] = parseFloat(retailPrice).toFixed(2)
            }
          })

        }
      },
      updateItems()
      {
        const updateArr = (key,value,priceList) =>
        {
          this.stock.barcodes.forEach(item =>
          {
            // ACQUISTO
            if(priceList == 'acquisto')
            {
              if(item.size == key)
              {
                item.costPrice = value
                item.discount = this.priceList.discount
                item.vat      = this.priceList.vat
              }
            }

            // VENDITA
            if(priceList == 'vendita')
            {
              if(item.size == key)
              {
                item.retailPrice = value
              }
            }

          })
        }
        this.priceList.items.forEach(e =>{
          var priceList = e.Listino
           //console.log(priceList)
          Object.entries(e).forEach(item => {
                      let key   = item[0]
                      let value = item[1]
                      //use key and value here
                      if (key!='Listino')
                      {
                        updateArr(key,value,priceList)
                        
                      }
          })
        })
     
      this.$nextTick(() => {
        //this.modalForm.Title = "SALVARE I DATI ?"
        
          $('#modalBox').modal({keyboard: false,backdrop:'static'})
        })
     

      },

     
      
  }
  
}
</script>

<style scoped>
    .inputClass
    {
        font-weight       : bold;
    }
    .loadingItem 
    {
        align-items: center;
        justify-content: center;
        display: flex;
    }
    label{
      color:blue
    }
    

    h4 {
      font-family  : 'Roboto Condensed';
      font-size    : 20px;
    }

    _span {
      font-family: 'Roboto Condensed';
      font-size: 16px;
    }
    .btn-link{
       font-family  : 'Roboto Condensed';
      font-size    : 12px;
    }

    input[type=number] {
  border: 1px solid;
 
}
input[type=number]:focus {
 border: 0px ;
 
 
}
.pointer{
  cursor: pointer;
}
.fa-clone
{
  color:darkgreen;;
}
</style>